import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import Card from '../../../../components/card/Card';
import ZipcodeInputWithButton from '../../../../components/zipcodeInputWithButton/ZipcodeInputWithButton';
import { useUserPrefs } from '../../../../context/UserPrefsProvider';

export default function ChargerMapLauncher(): JSX.Element {
  const { formatMessage } = useIntl();
  const history = useHistory();
  const { userPrefs, setUserPrefs } = useUserPrefs();

  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', sm: 'row' }}
      flexWrap="wrap"
      gap="2rem"
      maxWidth="990px"
      mx="auto"
    >
      <Box flex="3 1">
        <Typography component="h2" fontSize="2rem" fontWeight="500" lineHeight="1.2">
          {formatMessage({ id: 'evOwners.chargerMapLauncher.headline' })}
        </Typography>
        <Typography fontSize="24px" fontWeight="300" mb="0.5rem">
          {formatMessage({ id: 'evOwners.chargerMapLauncher.tagline' })}
        </Typography>
        <Typography fontSize="20px" fontWeight="300">
          {formatMessage({ id: 'evOwners.chargerMapLauncher.description' })}
        </Typography>
      </Box>
      <Box flex="1 1" minWidth="300px">
        <Card>
          <Box display="flex" flexDirection="column" gap="16px">
            <ZipcodeInputWithButton
              buttonText={formatMessage({ id: 'evOwners.chargerMapLauncher.startButton' })}
              zipcode={userPrefs.zipcode}
              onSubmitZipcode={(zipcode) => {
                setUserPrefs({ zipcode });
                history.push('/charging-stations');
              }}
            />
            <Box fontSize="0.85rem">
              {formatMessage({ id: 'evOwners.chargerMapLauncher.formDetails' })}
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  );
}
